export default __webpack_public_path__ + "static/media/SEI_ABC0047037102.a22b3ab0.pdf";